<template>
  <vxe-grid ref="engineerRankTable" v-bind="vxeOption" :loading="loading">
    <!-- 分页 -->
    <template #pager>
      <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
    </template>
  </vxe-grid>

</template>

<script>
import {
  allEngineerRankTableOptionColums,
  tableOption,
} from "@/views/report/indicators/option/tableOption.js";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import pager from "@/components/pager/index.vue";
export default {
  components: { pager },
  data() {
    return {
      vxeOption: {},
      pageSizes: [100, 200, 300],
      loading: true,
      isLoad: false,
      queryParams: {},
      page: {
        currentPage: 1,
        pageSize: 100
      }
    };
  },
  computed: {
    ...mapGetters(["engineerRankTableData"]),
  },
  watch: {
    engineerRankTableData: {
      deep: true,
      handler(newVal, oldVal) {
        this.getTableData();
      },
    },
  },
  methods: {
    ...mapActions(["GET_ENGINEER_RANK_TABLE_DATA"]),
    getTableData() {
      this.vxeOption.data = this.engineerRankTableData.records
      this.$refs.pager.tableDataTotal = this.engineerRankTableData.total
      this.loading = false;
      // this.$refs.engineerRankTable.reloadData();
    },
    changeTablePage(page, flag) {
      this.queryParams.size = page.pageSize;
      this.queryParams.current = page.currentPage;
      this.queryParams.searchCount = flag;
      if (this.isLoad) {
        this.searchEvent();
      }
      this.isLoad = true;
    },
    searchEvent() {
      var _queryParams = Object.assign({}, this.queryParams, this.queryParamsByFilter);
      this.loading = true;
      this.GET_ENGINEER_RANK_TABLE_DATA(_queryParams);
    },
    resetEvent() {
      this.queryParams = {};
      this.queryParams.size = this.page.pageSize;
      this.queryParams.current = this.page.currentPage;
      this.$refs.pager.page.currentPage = this.page.currentPage;
      this.$refs.pager.page.pageSize = this.page.pageSize;
      this.searchEvent()
    },
    init(params) {
      Object.assign(this.queryParams, params)
      this.queryParams.size = this.page.pageSize;
      this.queryParams.current = this.page.currentPage;
      this.searchEvent()
    }
  },
  created() {
    Object.assign(this.vxeOption, tableOption);
    this.vxeOption.columns = allEngineerRankTableOptionColums;
    this.vxeOption.pagerConfig = { pageSize: 100, pageSizes: [100, 200, 500, 1000] }
    this.vxeOption.loading = true
  },

  mounted() {
  },
};
</script>

<style lang="scss"></style>